import { useContext } from 'react';

import { WalletProviderContext } from './SmartWalletContext';

export const useSmartWallet = () => useContext(WalletProviderContext);
